module.exports = __webpack_public_path__ + "media/night/284-5a2c32e3.svg";